import React from 'react';
import { connect } from 'react-redux';
import TopHeader from '../template/TopHeader';
import MarketingTopNav from '../marketing/MarketingTopNav';
import LoyaltyContent from './LoyaltyContent';

// Marketing › Loyalty: thin page shell; content lives in LoyaltyContent so
// it renders (and is visually testable) without the app chrome.
function LoyaltyPage(props) {
  const salonName = props?.user?.userInfo?.hairdresser?.salon?.salonName || 'Your Salon';
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="loyalty" />
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <LoyaltyContent salonName={salonName} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(LoyaltyPage);
